import * as tslib_1 from "tslib";
import { connect } from '@nextiva/analytics-lib';
import { isFunction } from 'lodash';
import React from 'react';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import * as localStore from '../localStore';
import * as actions from '../state/actions';
import * as selectors from '../state/selectors';
import { isToggleAvailable, isToggleAvailableForFeature } from '../utils';

var FeaturesProvider =
/** @class */
function (_super) {
  tslib_1.__extends(FeaturesProvider, _super);

  function FeaturesProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.enableFeature = function (feature) {
      var currentUser = _this.props.currentUser;

      if (isToggleAvailableForFeature(currentUser, feature)) {
        _this.props.actions.enableFeature(feature);
      }
    };

    _this.disableFeature = function (feature) {
      var currentUser = _this.props.currentUser;

      if (isToggleAvailableForFeature(currentUser, feature)) {
        _this.props.actions.disableFeature(feature);
      }
    };

    return _this;
  }

  FeaturesProvider.prototype.componentDidMount = function () {
    var featuresFromLocalStore;

    if (isToggleAvailable(this.props.currentUser)) {
      featuresFromLocalStore = localStore.getFeatures();
    }

    this.props.actions.fetchAvailableFeatures(featuresFromLocalStore); // @ts-ignore

    window.enableFeature = this.enableFeature; // @ts-ignore

    window.disableFeature = this.disableFeature;
  };

  FeaturesProvider.prototype.render = function () {
    var _a = this.props,
        features = _a.features,
        children = _a.children;
    return isFunction(children) ? children({
      features: features
    }) : children;
  };

  return FeaturesProvider;
}(React.PureComponent);

var mapStateToProps = createStructuredSelector({
  features: selectors.featuresSelector
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default connect(FeaturesProvider, mapStateToProps, mapDispatchToProps);